import React from 'react'
import CloseButton from 'react-bootstrap/CloseButton'
import ButtonGroup from './ButtonGroup'
import Text from './Text'

import ListButton from './ListButton'
import TextWithOptions from './TextWithOptions'
import TextWithUrl from './TextWithUrl'
import Image from './Image'
import Action from './Action'

interface IProps {
  intent: any
  closeModal: () => void
  inputJson: any[]
  setInputJson: React.Dispatch<React.SetStateAction<any[]>>
  data: any
}

const CustomisationModal: React.FC<IProps> = ({
  intent,
  closeModal,
  inputJson,
  setInputJson,
  data
}) => {
  return (
    <div className='card h-600px w-400px'>
      <div className='d-flex justify-content-between mx-0 px-0 mb-2'>
        <span className='mb-2 me-auto'>
          <span className='ms-1 badge bg-info fs-5'># {intent.id}</span>
        </span>
        <CloseButton onClick={closeModal} />
      </div>
      {/* Render customisation Modal based on intent types */}
      {!!intent.interactive?.type && intent.interactive?.type === 'button' && (
        <ButtonGroup
          intent={intent}
          inputJson={inputJson}
          setInputJson={setInputJson}
          closeModal={closeModal}
          data={data}
        />
      )}
      {!!intent.text && intent.type === 'text' && (
        <Text
          intent={intent}
          inputJson={inputJson}
          setInputJson={setInputJson}
          closeModal={closeModal}
          data={data}
        />
      )}

      {!!intent.interactive?.type && intent.interactive?.type === 'list' && (
        <ListButton
          intent={intent}
          inputJson={inputJson}
          setInputJson={setInputJson}
          closeModal={closeModal}
          data={data}
        />
      )}

      {!!intent.type_text && intent.type_text === 'textWithOptions' && (
        <TextWithOptions
          intent={intent}
          inputJson={inputJson}
          setInputJson={setInputJson}
          closeModal={closeModal}
          data={data}
        />
      )}

      {!!intent.type && intent.type === 'text_with_url' && (
        <TextWithUrl
          intent={intent}
          inputJson={inputJson}
          setInputJson={setInputJson}
          closeModal={closeModal}
          data={data}
        />
      )}

      {!!intent.type && intent.type === 'image' && (
        <Image
          intent={intent}
          inputJson={inputJson}
          setInputJson={setInputJson}
          closeModal={closeModal}
          data={data}
        />
      )}

      {!!intent.type && intent.type === 'api' && (
        <Action
          intent={intent}
          inputJson={inputJson}
          setInputJson={setInputJson}
          closeModal={closeModal}
          data={data}
        />
      )}
    </div>
  )
}

export default CustomisationModal
